<template>
    <div class="page_content container-fluid">
    
        <div class="page_content_container">
        
        
                <!-- ico-catalog -->
                <div class="row" style="margin-top: 30px;">
                
                    <div class="col-3">
                        Course Catalogs
                    </div>
                    
                    <div class="col-2">
                        RGB
                        <input type="text" value="136" style="width: 50px;" disabled />
                        <input type="text" value="164" style="width: 50px;" disabled />
                        <input type="text" value="78" style="width: 50px;" disabled />
                    </div>
                    
                    <div class="col-1" style="background: rgb(136, 164, 78); height: 50px; width: 50px; margin-top: 10px;">
                        
                    </div>
                    
                    <div class="col-2">
                        <div class="thumbnail">
                            <span class="ico-catalog icon" style="font-size: 80px"></span>
                        </div>
                    </div>
                    
                    <div class="title-row">
                    </div>
                    
                </div>
                <!-- ico-catalog -->
            
            
        </div>
        
    </div>
</template>

<script>
    export default {
      name: 'app-color-theme',
      data: () => {
        return {
        }
      },

      mounted () {
      },

      methods: {
      },

      computed: {
      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/app/help/components/ColorTheme.vue